/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Manage_Storage_Scheduled_DescInputs */



/**
* | output |
* | --- |
* | "The current storage stays until {date}, then the change applies." |
*
* @param {Partner_Manage_Storage_Scheduled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_storage_scheduled_desc = /** @type {((inputs: Partner_Manage_Storage_Scheduled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Storage_Scheduled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der aktuelle Speicher bleibt bis zum ${i?.date}, dann wird die Änderung wirksam.`)
	return /** @type {LocalizedString} */ (`The current storage stays until ${i?.date}, then the change applies.`)
});